<template>
  <nav
    id="smrtl"
    class="navbar navbar-expand-lg header-navbar header-navbar-dashboard--v1"
  >
    <div class="container container--dashboard-nav">
      <!-- Mobile Layout -->
      <div class="d-lg-none w-100 mobile-navbar">
        <div class="mobile-navbar__bar">
          <router-link
            class="navbar-brand mobile-navbar__brand"
            :to="{ name: 'PublicHome' }"
            aria-label="صفحه اصلی"
          >
            <img
              :src="seoLogo"
              class="img-fluid"
              style="height: 3rem"
              alt="همراه زر"
            />
          </router-link>

          <div class="mobile-navbar__actions">
            <button
              class="mobile-notification-trigger"
              type="button"
              aria-label="اعلان‌ها"
              @click="toggleNotifications"
            >
              <MobileNavIcon name="bi-bell" />
              <span v-if="unreadCount" class="mobile-notification-trigger__badge">
                {{ toFaDigits(unreadCount) }}
              </span>
            </button>

            <router-link class="mobile-profile-trigger" :to="{ name: 'PanelUser-Profile' }" aria-label="پروفایل" title="پروفایل">
              <MobileNavIcon name="bi-person" />
            </router-link>
          </div>
        </div>
      </div>

      <!-- Desktop Layout -->
      <div class="d-none d-lg-flex w-100 align-items-center desktop-navbar">
        <router-link class="navbar-brand" :to="{ name: 'PublicHome' }">
          <img
            :src="seoLogo"
            class="img-fluid"
            style="height: 5rem"
            alt=""
          />
        </router-link>

        <div class="navbar-collapse" id="navbarSupportedContent">
          <div class="navbar-collapse__content show">
            <div class="desktop-navbar__center">
              <ul class="navbar-nav desktop-navbar__nav">
                <li
                  v-for="item in desktopMenuItems"
                  :key="item.name"
                  class="nav-item desktop-navbar__item"
                >
                  <router-link
                    class="nav-link sidebar-item-active desktop-navbar__link"
                    :to="{ name: item.name }"
                  >
                    <span>{{ item.label }}</span>
                    <span v-if="item.comingSoon" class="badge-coming-soon">
                      به زودی
                    </span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="navbar-right">
          <div class="navbar-notifications">
            <button
              ref="notificationTrigger"
              type="button"
              class="navbar-notifications__button"
              aria-label="اعلان‌ها"
              @click="toggleNotifications"
            >
              <img
                src="/assets/media/images/icons/notifications.svg"
                alt="notifications-icon"
                class="navbar-notifications__image"
              />
              <span v-if="unreadCount" class="navbar-notifications__badge">
                {{ toFaDigits(unreadCount) }}
              </span>
            </button>
          </div>
          <div
            class="navbar-profile-menu"
          >
            <button
              ref="profileMenuTrigger"
              type="button"
              class="navbar-profile-menu__trigger"
              :aria-expanded="isProfileMenuOpen.toString()"
              aria-label="منوی حساب کاربری"
              @click.stop="toggleProfileMenu"
            >
              <p class="navbar-profile-menu__text">
                {{ profileDisplay || "حساب کاربری" }}
              </p>
              <img
                :src="profileImageSrc"
                alt="profile-photo-icon"
                class="navbar-profile-menu__image"
              />
              <img
                src="/assets/media/images/icons/arrow-down.svg"
                alt="arrow-down-icon"
                class="navbar-profile-menu__arrow"
                :class="{ 'navbar-profile-menu__arrow--open': isProfileMenuOpen }"
              />
            </button>
            <div
              ref="profileMenuPanel"
              class="navbar-profile-menu__dropdown"
              :class="{
                'navbar-profile-menu__dropdown--open': isProfileMenuOpen,
                active: isProfileMenuOpen,
              }"
              @click.stop
            >
              <div class="navbar-profile-menu__dropdown-header">
                <div class="navbar-profile-menu__dropdown-avatar">
                  {{ profileInitial }}
                </div>
                <div class="navbar-profile-menu__dropdown-meta">
                  <strong>{{ profileDisplay || "حساب کاربری" }}</strong>
                  <span>مدیریت پروفایل و خروج امن از حساب</span>
                </div>
              </div>
              <div class="navbar-profile-menu__dropdown-item">
                <router-link
                  class="fb-regular dropdown-item__link"
                  :to="{ name: 'PanelUser-Profile' }"
                  @click="closeProfileMenu"
                >
                  <i class="bi bi-person-circle"></i>
                  <span>پروفایل</span>
                </router-link>
              </div>
              <div class="navbar-profile-menu__dropdown-item">
                <a class="fb-regular dropdown-item__link" href="#" @click.prevent="logout">
                  <i class="bi bi-box-arrow-right"></i>
                  <span>خروج از سیستم</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Teleport to="body"><transition name="mobile-menu-fade">
        <div v-if="isMobileMenuOpen" class="mobile-menu-overlay" @click.self="closeMobileMenu" @keydown="handleMobileMenuKey">
          <div ref="mobileMenuPanel" id="hz-mobile-menu" class="mobile-menu-panel" role="dialog" aria-modal="true" aria-labelledby="hz-mobile-menu-title" tabindex="-1">
            <div class="mobile-menu-panel__header">
              <div>
                <p class="mobile-menu-panel__eyebrow">همراه زر</p>
                <h6 id="hz-mobile-menu-title" class="mobile-menu-panel__title">منوی حساب کاربری</h6>
              </div>
              <button type="button" class="mobile-menu-panel__close" @click="closeMobileMenu" aria-label="بستن منو">
                <MobileNavIcon name="bi-x-lg" />
              </button>
            </div>

            <div class="mobile-menu-links">
              <router-link
                v-for="item in mobileMenuItems"
                :key="item.name"
                class="mobile-menu-link"
                :to="item.to || { name: item.name }"
                @click="closeMobileMenu"
              >
                <div class="mobile-menu-link__icon">
                  <MobileNavIcon :name="item.icon" />
                </div>
                <div class="mobile-menu-link__content">
                  <span class="mobile-menu-link__title">{{ item.label }}</span>
                  <span class="mobile-menu-link__meta">{{ item.description }}</span>
                </div>
                <span v-if="item.comingSoon" class="badge-coming-soon">به زودی</span>
                <i class="bi bi-chevron-left mobile-menu-link__arrow"></i>
              </router-link>

              <button type="button" class="mobile-menu-link mobile-menu-link--logout" @click="logout">
                <div class="mobile-menu-link__icon">
                  <MobileNavIcon name="bi-box-arrow-right" />
                </div>
                <div class="mobile-menu-link__content">
                  <span class="mobile-menu-link__title">خروج</span>
                  <span class="mobile-menu-link__meta">خروج امن از حساب کاربری</span>
                </div>
                <i class="bi bi-chevron-left mobile-menu-link__arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </transition></Teleport>

      <transition name="notification-fade">
        <div v-if="isNotificationOpen" class="notification-overlay" @click.self="closeNotifications">
          <div ref="notificationPanel" class="notification-panel">
            <div class="notification-panel__header">
              <div>
                <p class="notification-panel__eyebrow">مرکز اعلان</p>
                <h6 class="notification-panel__title">آخرین بروزرسانی‌های حساب شما</h6>
              </div>
              <button type="button" class="notification-panel__close" @click="closeNotifications" aria-label="بستن اعلان‌ها">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>

            <div class="notification-panel__summary">
              <div class="notification-summary-card">
                <span class="notification-summary-card__label">خوانده نشده</span>
                <strong>{{ toFaDigits(unreadCount) }}</strong>
              </div>
              <button
                type="button"
                class="notification-panel__read-all"
                :disabled="!unreadCount || notificationsLoading"
                @click="markAllNotificationsRead"
              >
                خواندن همه
              </button>
            </div>

            <div v-if="notificationsLoading && !notificationItems.length" class="notification-panel__empty">
              در حال بارگذاری اعلان‌ها...
            </div>

            <div v-else-if="!notificationItems.length" class="notification-panel__empty">
              هنوز اعلانی برای شما ثبت نشده است.
            </div>

            <div v-else class="notification-panel__list">
              <button
                v-for="item in notificationItems"
                :key="item._id"
                type="button"
                class="notification-card"
                :class="{ 'notification-card--unread': !item.isRead }"
                @click="handleNotificationClick(item)"
              >
                <div class="notification-card__icon" :class="notificationTypeClass(item.type)">
                  <i :class="notificationIcon(item)"></i>
                </div>
                <div class="notification-card__content">
                  <div class="notification-card__top">
                    <strong>{{ item.title || "اعلان جدید" }}</strong>
                    <span class="notification-card__time">{{ formatNotificationDate(item.createdAt) }}</span>
                  </div>
                  <p class="notification-card__message">{{ item.message }}</p>
                  <div class="notification-card__meta">
                    <span class="notification-card__category">{{ notificationCategoryLabel(item.category) }}</span>
                    <span v-if="!item.isRead" class="notification-card__dot"></span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </transition>

      <div class="navbar-search-popup d-none d-lg-block">
        <input
          type="text"
          class="navbar-search-popup__input js-navbar-search-popup__input"
          placeholder="جستجو"
        />
        <img
          src="/assets/media/images/icons/search.svg"
          alt="search-icon"
          class="navbar-search-popup__image"
        />
        <img
          src="/assets/media/images/icons/plus-icon.svg"
          alt="cancel-icon"
          class="navbar-search-popup__image--cancel js-navbar-search-popup__image--cancel"
        />
      </div>
    </div>
  </nav>
</template>

<script>
import axios from "axios";
import {seoBrand} from "@/services/seoBrand";
import MobileNavIcon from "./MobileNavIcon.vue";
import Swal from "sweetalert2";
import { englishToPersianDigits } from "@/utils/numberFormatter";

export default {
  components: {MobileNavIcon},
  data() {
    return {
      isMobileMenuOpen: false,
      isNotificationOpen: false,
      isProfileMenuOpen: false,
      notificationsLoading: false,
      notificationItems: [],
      unreadCount: 0,
      notificationIntervalId: null,
    };
  },
  computed: {
    seoLogo() { return seoBrand.logo || "/assets/logo/i.png"; },
    isAuthenticated() {
      return this.$store && this.$store.state && this.$store.state.userIsAuthenticated;
    },
    isKycVerified() {
      const ud = (this.$store && this.$store.state && this.$store.state.userDetails) || {};
      const status = ud.kycStatus || (ud.kyc && ud.kyc.status) || ud.kyc_verified;
      return status === "verified" || status === true;
    },
    userFullName() {
      const ud = (this.$store && this.$store.state && this.$store.state.userDetails) || {};
      const first = (ud.firstName || ud.firstname || ud.first_name || "").toString().trim();
      const last = (ud.lastName || ud.lastname || ud.last_name || "").toString().trim();
      return [first, last].filter(Boolean).join(" ");
    },
    userMobileFa() {
      // prefer userDetails, but fall back to localStorage validated user snapshot if present
      const ud = (this.$store && this.$store.state && this.$store.state.userDetails) || {};
      const fallbackUser = JSON.parse(localStorage.getItem('hz_user_cache') || '{}');
      const mobile = (ud.mobile || ud.phone || ud.phoneNumber || fallbackUser.mobile || "").toString();
      return mobile ? englishToPersianDigits(mobile) : "";
    },
    profileDisplay() {
      // Remove placeholder. If not authenticated show empty; when authenticated show phone immediately.
      if (!this.isAuthenticated) return "";
      return this.userFullName || this.userMobileFa;
    },
    profileImageSrc() {
      return "/assets/media/images/icons/profile-pict.svg";
    },
    profileInitial() {
      const value = (this.profileDisplay || "ک").toString().trim();
      return value ? value.charAt(0) : "ک";
    },
    desktopMenuItems() {
      return [
        { name: "PanelUser-Dashboard", label: "داشبورد" },
        { name: "PanelUser-Exchange", label: "تبادل" },
        { name: "PanelUser-Wallet", label: "افزایش موجودی" },
        { name: "PanelUser-ProductOrders", label: "سفارش محصولات" },
        { name: "PanelUser-Withdraws", label: "برداشت" },
        { name: "PanelUser-Referal", label: "کد دعوت" },
        { name: "PanelUser-Gldtogld", label: "طلا به طلا", comingSoon: true },
        { name: "PanelUser-Card", label: "کارت ها" },
        { name: "PanelUser-Tickets", label: "پشتیبانی" },
      ];
    },
    mobileMenuItems() {
      return [
        { name: "mobile-reports", to: "/user/reports", label: "گزارشات", icon: "bi bi-file-earmark-bar-graph" },
        { name: "PanelUser-Dashboard", label: "داشبورد", description: "نمای کلی دارایی و وضعیت حساب", icon: "bi bi-grid-1x2" },
        { name: "PanelUser-Exchange", label: "تبادل", description: "خرید و فروش سریع طلا", icon: "bi bi-arrow-down-up" },
        { name: "PanelUser-Wallet", label: "افزایش موجودی", description: "شارژ کیف پول و مدیریت واریز", icon: "bi bi-wallet2" },
        { name: "PanelUser-ProductOrders", label: "سفارش محصولات", description: "پیگیری خریدهای فروشگاه و وضعیت تحویل", icon: "bi bi-bag-check" },
        { name: "PanelUser-Withdraws", label: "برداشت", description: "ثبت و پیگیری درخواست‌های برداشت", icon: "bi bi-cash-stack" },
        { name: "PanelUser-Referal", label: "کد دعوت", description: "دعوت از دوستان و مشاهده معرفی‌ها", icon: "bi bi-megaphone" },
        { name: "PanelUser-Gldtogld", label: "طلا به طلا", description: "سرویس تبدیل داخلی همراه زر", icon: "bi bi-stars", comingSoon: true },
        { name: "PanelUser-Card", label: "کارت ها", description: "مدیریت کارت‌ها و حساب‌های بانکی", icon: "bi bi-credit-card-2-front" },
        { name: "PanelUser-Tickets", label: "پشتیبانی", description: "پیگیری درخواست‌ها و گفتگو با پشتیبانی", icon: "bi bi-headset" },
        { name: "PanelUser-Profile", label: "پروفایل", description: "ویرایش اطلاعات و تنظیمات حساب", icon: "bi bi-person" },
      ];
    },
  },
  async mounted() {
    this.mobileMenuRequest = () => { if (window.innerWidth < 992) this.toggleMobileMenu(); };
    this.mobileMenuResize = () => { if (window.innerWidth >= 992) this.closeMobileMenu(); };
    window.addEventListener('hz:mobile-menu-toggle', this.mobileMenuRequest);
    window.addEventListener('resize', this.mobileMenuResize);
    document.addEventListener("click", this.handleOutsideClick);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    await this.refreshNotifications({ withList: false });
    this.notificationIntervalId = window.setInterval(() => {
      this.refreshNotifications({ withList: this.isNotificationOpen });
    }, 30000);
  },
  methods: {
    handleMobileMenuKey(event) {
      if (event.key === 'Escape') { event.preventDefault(); this.closeMobileMenu(); return; }
      if (event.key !== 'Tab') return;
      const panel = this.$refs.mobileMenuPanel;
      const nodes = [...panel.querySelectorAll('a[href], button:not(:disabled)')];
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    },
    async refreshNotifications({ withList = false } = {}) {
      if (!this.isAuthenticated) return;
      await this.fetchNotificationSummary();
      if (withList) {
        await this.fetchNotificationItems();
      }
    },
    async fetchNotificationSummary() {
      try {
        const response = await axios.get("/v2/notifications/summary");
        const data = response?.data?.data || {};
        this.unreadCount = Number(data.unreadCount || 0);
      } catch (_) {}
    },
    async fetchNotificationItems() {
      try {
        this.notificationsLoading = true;
        const response = await axios.get("/v2/notifications", {
          params: {
            limit: 12,
          },
        });
        const data = response?.data?.data || {};
        this.notificationItems = Array.isArray(data.items) ? data.items : [];
        this.unreadCount = Number(data.unreadCount || this.unreadCount || 0);
      } catch (_) {
        this.notificationItems = [];
      } finally {
        this.notificationsLoading = false;
      }
    },
    handleConfirmationLogout() {
      this.$router.push({ name: "PanelUser-Logout" });
    },
    logout() {
      this.closeMobileMenu();
      this.closeProfileMenu();
      Swal.fire({
        title: "آیا مطمین هستید ؟",
        text: "آیا میخواین از حساب کاربری خود خارج شوید ؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "بله",
        cancelButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleConfirmationLogout();
        }
      });
    },
    toggleMobileMenu() {
      this.closeNotifications(); this.closeProfileMenu();
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    toggleProfileMenu() {
      if (!this.isAuthenticated) return;
      this.closeNotifications();
      this.isProfileMenuOpen = !this.isProfileMenuOpen;
    },
    openProfileMenu() {
      if (!this.isAuthenticated) return;
      this.closeNotifications();
      this.isProfileMenuOpen = true;
    },
    closeProfileMenu() {
      this.isProfileMenuOpen = false;
    },
    async toggleNotifications() {
      if (!this.isAuthenticated) return;
      this.closeProfileMenu();
      this.isNotificationOpen = !this.isNotificationOpen;
      if (this.isNotificationOpen) {
        await this.fetchNotificationItems();
      }
    },
    closeNotifications() {
      this.isNotificationOpen = false;
    },
    async handleNotificationClick(item) {
      if (!item?._id) return;

      if (!item.isRead) {
        try {
          await axios.post(`/v2/notifications/${item._id}/read`);
          item.isRead = true;
          item.readAt = new Date().toISOString();
          this.unreadCount = Math.max(0, this.unreadCount - 1);
        } catch (_) {}
      }

      this.closeNotifications();

      if (item.route?.name) {
        this.$router.push({
          name: item.route.name,
          params: item.route.params || {},
          query: item.route.query || {},
        }).catch(() => {});
      }
    },
    async markAllNotificationsRead() {
      try {
        this.notificationsLoading = true;
        await axios.post("/v2/notifications/read-all");
        this.unreadCount = 0;
        this.notificationItems = this.notificationItems.map((item) => ({
          ...item,
          isRead: true,
          readAt: item.readAt || new Date().toISOString(),
        }));
      } catch (_) {
      } finally {
        this.notificationsLoading = false;
      }
    },
    notificationIcon(item) {
      const category = item?.category || "";
      if (category === "ticket") return "bi bi-chat-dots";
      if (category === "manual-payment") return "bi bi-credit-card-2-front";
      if (category === "withdraw") return "bi bi-wallet2";
      if (category === "order") return "bi bi-arrow-down-up";
      if (category === "product-order") return "bi bi-bag-check";
      return "bi bi-bell";
    },
    notificationTypeClass(type) {
      return {
        "notification-card__icon--success": type === "success",
        "notification-card__icon--warning": type === "warning",
        "notification-card__icon--error": type === "error",
        "notification-card__icon--info": !["success", "warning", "error"].includes(type),
      };
    },
    notificationCategoryLabel(category) {
      const labels = {
        ticket: "تیکت",
        wallet: "کیف پول",
        "manual-payment": "کارت به کارت",
        withdraw: "برداشت",
        order: "معامله",
        "product-order": "سفارش محصول",
      };
      return labels[category] || "عمومی";
    },
    formatNotificationDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("fa-IR", {
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    toFaDigits(value) {
      return englishToPersianDigits(value ?? "");
    },
    syncBodyScrollLock(isLocked) {
      document.body.style.overflow = isLocked ? "hidden" : "";
    },
    handleOutsideClick(event) {
      if (this.isNotificationOpen) {
        const panel = this.$refs.notificationPanel;
        const trigger = this.$refs.notificationTrigger;
        if (
          !panel?.contains(event.target) &&
          !trigger?.contains(event.target) &&
          !event.target.closest(".mobile-notification-trigger")
        ) {
          this.closeNotifications();
        }
      }

      if (this.isProfileMenuOpen) {
        const profilePanel = this.$refs.profileMenuPanel;
        const profileTrigger = this.$refs.profileMenuTrigger;
        if (!profilePanel?.contains(event.target) && !profileTrigger?.contains(event.target)) {
          this.closeProfileMenu();
        }
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.refreshNotifications({ withList: this.isNotificationOpen });
      }
    },
  },
  watch: {
    isMobileMenuOpen(value) {
      this.syncBodyScrollLock(value);
      window.dispatchEvent(new CustomEvent('hz:mobile-menu-state', {detail:value}));
      if (value) { this.mobileMenuPreviousFocus = document.activeElement; this.$nextTick(() => this.$refs.mobileMenuPanel?.focus()); }
      else { this.mobileMenuPreviousFocus?.focus?.(); }
    },
    $route() {
      this.closeMobileMenu();
      this.closeNotifications();
      this.closeProfileMenu();
      this.fetchNotificationSummary();
    },
  },
  beforeUnmount() {
    window.removeEventListener('hz:mobile-menu-toggle', this.mobileMenuRequest);
    window.removeEventListener('resize', this.mobileMenuResize);
    window.dispatchEvent(new CustomEvent('hz:mobile-menu-state', {detail:false}));
    this.syncBodyScrollLock(false);
    if (this.notificationIntervalId) {
      window.clearInterval(this.notificationIntervalId);
    }
    document.removeEventListener("click", this.handleOutsideClick);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
};
</script>

<style scoped>
.router-link-active.sidebar-item-active {
  color: white !important;
  font-weight: bold;
}

.badge-coming-soon {
  background: rgba(239, 177, 0, 0.15);
  color: var(--bs-gold-light);
  font-size: 0.7rem;
  border-radius: 6px;
  padding: 2px 6px;
  margin-right: 6px;
}

/* Mobile Layout Styles */
.mobile-navbar {
  min-height: 74px;
  padding: 0.5rem 0 0.35rem;
}

.mobile-navbar__bar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  direction: ltr;
  gap: 0.85rem;
}

.mobile-navbar__brand {
  grid-column: 2;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
}

.mobile-navbar__brand img {
  display: block;
}

.mobile-menu-trigger {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  border: 1px solid rgba(239, 177, 0, 0.16);
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
}

.mobile-navbar__actions {
  grid-column: 3;
  justify-self: end;
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
}

.mobile-notification-trigger,
.navbar-notifications__button {
  position: relative;
  border: 1px solid rgba(239, 177, 0, 0.16);
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
}

.mobile-notification-trigger {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mobile-notification-trigger:hover,
.navbar-notifications__button:hover {
  background: rgba(239, 177, 0, 0.08);
  border-color: rgba(239, 177, 0, 0.28);
}

.mobile-notification-trigger__badge,
.navbar-notifications__badge {
  position: absolute;
  top: -6px;
  left: -6px;
  min-width: 22px;
  height: 22px;
  border-radius: 999px;
  padding: 0 6px;
  background: linear-gradient(135deg, #efb100, #f6ca42);
  color: #16171b;
  font-size: 0.72rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 18px rgba(239, 177, 0, 0.24);
}

.mobile-menu-trigger i {
  font-size: 1.35rem;
}

.mobile-menu-trigger:hover {
  background: rgba(239, 177, 0, 0.08);
  border-color: rgba(239, 177, 0, 0.28);
}

.mobile-user-chip {
  grid-column: 1;
  justify-self: start;
  min-width: 0;
  width: 100%;
  max-width: 170px;
  padding: 0.5rem 0.65rem;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  gap: 0.55rem;
  direction: rtl;
  text-align: right;
}

.mobile-user-chip__avatar {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(239, 177, 0, 0.16);
  color: var(--bs-gold-light);
  font-size: 0.95rem;
  font-weight: 700;
  flex-shrink: 0;
}

.mobile-user-chip__content {
  min-width: 0;
  flex: 1;
}

.mobile-user-chip__title,
.mobile-user-chip__value {
  margin: 0;
}

.mobile-user-chip__title {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.68rem;
  margin-bottom: 0.1rem;
}

.mobile-user-chip__value {
  color: #fff;
  font-size: 0.78rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(4, 5, 8, 0.55);
  backdrop-filter: blur(8px);
  padding: 0.75rem;
}

.mobile-menu-panel {
  width: 100%;
  max-height: calc(100vh - 1.5rem);
  overflow-y: auto;
  border-radius: 28px;
  background:
    radial-gradient(circle at top right, rgba(239, 177, 0, 0.16), transparent 28%),
    linear-gradient(180deg, rgba(20, 21, 27, 0.98) 0%, rgba(14, 15, 20, 0.98) 100%);
  border: 1px solid rgba(239, 177, 0, 0.14);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.42);
  padding: 1rem;
  direction: rtl;
  text-align: right;
}

.mobile-menu-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.mobile-menu-panel__eyebrow {
  margin: 0 0 0.35rem;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.76rem;
}

.mobile-menu-panel__title {
  margin: 0;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
}

.mobile-menu-panel__close {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mobile-menu-panel__user {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.95rem 1rem;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 1rem;
}

.mobile-menu-panel__avatar {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(239, 177, 0, 0.14);
  color: var(--bs-gold-light);
  font-size: 1rem;
  font-weight: 700;
  flex-shrink: 0;
}

.mobile-menu-panel__user-text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.mobile-menu-panel__user-text strong {
  color: #fff;
  font-size: 0.92rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-menu-panel__user-text span {
  color: rgba(255, 255, 255, 0.58);
  font-size: 0.78rem;
  line-height: 1.7;
}

.mobile-menu-links {
  display: grid;
  gap: 0.75rem;
}

.mobile-menu-link {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.95rem 1rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  text-decoration: none;
  color: #fff;
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
  text-align: right;
}

.mobile-menu-link:hover,
.mobile-menu-link.router-link-active {
  color: #fff;
  border-color: rgba(239, 177, 0, 0.22);
  background: rgba(239, 177, 0, 0.08);
}

.mobile-menu-link--logout {
  text-align: right;
}

.mobile-menu-link__icon {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(239, 177, 0, 0.12);
  color: var(--bs-gold-light);
  flex-shrink: 0;
}

.mobile-menu-link__content {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  min-width: 0;
  flex: 1;
}

.mobile-menu-link__title {
  color: #fff;
  font-size: 0.93rem;
  font-weight: 700;
}

.mobile-menu-link__meta {
  color: rgba(255, 255, 255, 0.56);
  font-size: 0.77rem;
  line-height: 1.7;
}

.mobile-menu-link__arrow {
  color: rgba(255, 255, 255, 0.38);
  font-size: 0.85rem;
  flex-shrink: 0;
}

/* Desktop Layout Styles */
.desktop-navbar {
  min-height: 80px;
  position: relative;
  overflow: visible;
  direction: rtl;
  justify-content: space-between;
  gap: 1rem;
}

.desktop-navbar .navbar-collapse {
  flex: 1;
  min-width: 0;
  overflow: visible;
  display: flex;
  justify-content: center;
}

.container--dashboard-nav,
.desktop-navbar .navbar-collapse__content,
.navbar-right,
.navbar-profile-menu {
  overflow: visible !important;
}

.desktop-navbar .navbar-nav .nav-link {
  white-space: nowrap;
}

.desktop-navbar__center {
  width: 100%;
  display: flex;
  justify-content: center;
}

.desktop-navbar__nav {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin: 0;
  padding: 0;
}

.desktop-navbar__item {
  display: flex;
}

.desktop-navbar__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 44px;
  padding: 0.65rem 0.9rem !important;
  border-radius: 14px;
  color: rgba(255, 255, 255, 0.66) !important;
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.2;
  transition: color 0.2s ease, background 0.2s ease;
}

.desktop-navbar__link:hover,
.desktop-navbar__link.router-link-active {
  color: #fff !important;
  background: rgba(239, 177, 0, 0.08);
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-shrink: 0;
  position: relative;
  z-index: 8;
}

.navbar-notifications__button {
  width: 52px;
  height: 52px;
  border-radius: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.navbar-notifications__image {
  width: 22px;
  height: 22px;
}

.navbar-profile-menu {
  position: relative;
  flex-shrink: 0;
  z-index: 12;
}

.navbar-profile-menu__trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  min-height: 52px;
  min-width: 204px;
  justify-content: space-between;
  padding: 0.45rem 0.8rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.navbar-profile-menu__trigger:hover {
  background: rgba(239, 177, 0, 0.08);
  border-color: rgba(239, 177, 0, 0.24);
}

.navbar-profile-menu__text {
  margin: 0;
  flex: 1;
  max-width: 132px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff;
  font-size: 0.88rem;
  text-align: right;
}

.navbar-profile-menu__image {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.navbar-profile-menu__arrow {
  width: 14px;
  height: 14px;
  transition: transform 0.2s ease;
}

.navbar-profile-menu__arrow--open {
  transform: rotate(180deg);
}

.navbar-profile-menu__dropdown {
  position: absolute;
  top: calc(100% + 0.6rem);
  left: auto;
  right: 0;
  min-width: 220px;
  padding: 0.65rem;
  border-radius: 18px;
  background:
    radial-gradient(circle at top right, rgba(239, 177, 0, 0.15), transparent 30%),
    linear-gradient(180deg, rgba(20, 21, 27, 0.98) 0%, rgba(13, 14, 19, 0.98) 100%);
  border: 1px solid rgba(239, 177, 0, 0.16);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.32);
  display: block;
  z-index: 1200;
  direction: rtl;
  text-align: right;

  /* Hide by default for hover logic */
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}

/* Hover bridge to prevent closing when moving between trigger and dropdown */
.navbar-profile-menu__dropdown::before {
  content: "";
  position: absolute;
  top: -0.7rem;
  left: 0;
  right: 0;
  height: 0.7rem;
  background: transparent;
}

/* Show on hover for desktop */
@media (min-width: 992px) {
  .navbar-profile-menu:hover .navbar-profile-menu__dropdown {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    pointer-events: auto;
  }
}

/* Show when open state is active (for mobile or manual toggle) */
.navbar-profile-menu__dropdown--open,
.navbar-profile-menu__dropdown.active {
  opacity: 1 !important;
  visibility: visible !important;
  transform: translateY(0) !important;
  pointer-events: auto !important;
}

.navbar-profile-menu__dropdown-header {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 0.85rem 1rem;
}

.navbar-profile-menu__dropdown-avatar {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(239, 177, 0, 0.15);
  color: var(--bs-gold-light);
  font-weight: 800;
  flex-shrink: 0;
}

.navbar-profile-menu__dropdown-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.navbar-profile-menu__dropdown-meta strong {
  color: #fff;
  font-size: 0.92rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-profile-menu__dropdown-meta span {
  color: rgba(255, 255, 255, 0.56);
  font-size: 0.74rem;
}

.navbar-profile-menu__dropdown-item + .navbar-profile-menu__dropdown-item {
  margin-top: 0.35rem;
}

.dropdown-item__link {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.7rem;
  min-height: 46px;
  padding: 0.8rem 0.95rem;
  border-radius: 14px;
  text-decoration: none;
  color: #fff;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: background 0.2s ease, border-color 0.2s ease;
}

.dropdown-item__link:hover,
.dropdown-item__link.router-link-active {
  color: #fff;
  background: rgba(239, 177, 0, 0.08);
  border-color: rgba(239, 177, 0, 0.22);
}

.dropdown-item__link i {
  color: var(--bs-gold-light);
  font-size: 1rem;
}

.notification-overlay {
  position: fixed;
  inset: 0;
  z-index: 1150;
  background: rgba(5, 8, 14, 0.42);
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 5.75rem 1rem 1rem;
  backdrop-filter: blur(10px);
}

.notification-panel {
  width: min(420px, 100%);
  max-height: calc(100vh - 7rem);
  overflow: hidden;
  border-radius: 28px;
  background:
    radial-gradient(circle at top right, rgba(239, 177, 0, 0.17), transparent 28%),
    linear-gradient(180deg, rgba(20, 21, 27, 0.98) 0%, rgba(13, 14, 19, 0.98) 100%);
  border: 1px solid rgba(239, 177, 0, 0.16);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.38);
  display: flex;
  flex-direction: column;
  direction: rtl;
  text-align: right;
}

.notification-panel__header,
.notification-panel__summary {
  padding: 1rem 1rem 0;
}

.notification-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.notification-panel__eyebrow {
  margin: 0 0 0.35rem;
  color: rgba(255, 255, 255, 0.52);
  font-size: 0.76rem;
}

.notification-panel__title {
  margin: 0;
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
}

.notification-panel__close {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.notification-panel__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-top: 1rem;
}

.notification-summary-card {
  flex: 1;
  min-height: 72px;
  padding: 0.95rem 1rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.28rem;
}

.notification-summary-card__label {
  color: rgba(255, 255, 255, 0.58);
  font-size: 0.78rem;
}

.notification-summary-card strong {
  color: var(--bs-gold-light);
  font-size: 1.1rem;
}

.notification-panel__read-all {
  border: none;
  border-radius: 16px;
  background: rgba(239, 177, 0, 0.12);
  color: var(--bs-gold-light);
  min-height: 48px;
  padding: 0 1rem;
  font-weight: 700;
}

.notification-panel__read-all:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.notification-panel__list {
  padding: 1rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.notification-panel__empty {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.56);
  padding: 1rem;
}

.notification-card {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.035);
  border-radius: 20px;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  text-align: right;
  color: #fff;
  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.notification-card:hover {
  transform: translateY(-1px);
  border-color: rgba(239, 177, 0, 0.26);
  background: rgba(239, 177, 0, 0.06);
}

.notification-card--unread {
  border-color: rgba(239, 177, 0, 0.2);
  box-shadow: inset 0 0 0 1px rgba(239, 177, 0, 0.08);
}

.notification-card__icon {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.15rem;
}

.notification-card__icon--info {
  background: rgba(59, 130, 246, 0.14);
  color: #93c5fd;
}

.notification-card__icon--success {
  background: rgba(16, 185, 129, 0.14);
  color: #6ee7b7;
}

.notification-card__icon--warning {
  background: rgba(239, 177, 0, 0.14);
  color: var(--bs-gold-light);
}

.notification-card__icon--error {
  background: rgba(239, 68, 68, 0.14);
  color: #fda4af;
}

.notification-card__content {
  flex: 1;
  min-width: 0;
}

.notification-card__top,
.notification-card__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.notification-card__top strong {
  font-size: 0.95rem;
}

.notification-card__time,
.notification-card__category {
  color: rgba(255, 255, 255, 0.54);
  font-size: 0.76rem;
  white-space: nowrap;
}

.notification-card__message {
  margin: 0.45rem 0 0.65rem;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.9;
}

.notification-card__dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: var(--bs-gold-light);
  box-shadow: 0 0 0 6px rgba(239, 177, 0, 0.12);
}

.desktop-navbar .navbar-collapse__content {
  opacity: 1 !important;
  transform: translateY(0) !important;
  display: flex !important;
}

/* Responsive Breakpoints */
@media (max-width: 991.98px) {
  .desktop-navbar {
    display: none !important;
  }
  
  .mobile-navbar {
    display: flex !important;
  }
  
  .navbar-search-popup {
    display: none !important;
  }

  .notification-overlay {
    justify-content: center;
    padding: 0.75rem;
    align-items: flex-start;
  }

  .notification-panel {
    width: 100%;
    max-height: calc(100vh - 1.5rem);
    margin-top: 4.75rem;
  }
}

@media (min-width: 992px) {
  .mobile-navbar {
    display: none !important;
  }

  .desktop-navbar {
    display: flex !important;
  }

  .desktop-navbar .navbar-collapse {
    display: flex !important;
  }

  .desktop-navbar .navbar-collapse__content {
    opacity: 1 !important;
    transform: translateY(0) !important;
    display: flex !important;
    flex-grow: 1;
    gap: 0.75rem;
    align-items: center;
  }
}

/* Small mobile devices */
@media (max-width: 576px) {
  .mobile-user-chip {
    max-width: 148px;
    padding: 0.4rem 0.5rem;
  }

  .mobile-user-chip__avatar {
    width: 30px;
    height: 30px;
    border-radius: 10px;
  }

  .mobile-user-chip__value {
    font-size: 0.72rem;
  }

  .mobile-menu-panel {
    padding: 0.85rem;
    border-radius: 24px;
  }

  .notification-panel {
    border-radius: 24px;
  }

  .mobile-menu-link {
    padding: 0.85rem 0.9rem;
  }
}

/* Extra small devices */
@media (max-width: 375px) {
  .mobile-user-chip__title {
    display: none;
  }

  .mobile-user-chip {
    max-width: 118px;
  }
}

/* RTL Support */
[dir="rtl"] .mobile-navbar {
  direction: rtl;
}

[dir="rtl"] .mobile-menu-panel__user {
  flex-direction: row-reverse;
}

[dir="rtl"] .badge-coming-soon {
  margin-right: 0;
  margin-left: 6px;
}

.mobile-menu-fade-enter-active,
.mobile-menu-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.mobile-menu-fade-enter-from,
.mobile-menu-fade-leave-to {
  opacity: 0;
}

.notification-fade-enter-active,
.notification-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.notification-fade-enter-from,
.notification-fade-leave-to {
  opacity: 0;
}

.navbar-collapse__content {
  transition: none;
}
</style>

<style scoped>
@media(max-width:991.98px){
 .mobile-navbar{min-height:60px;padding:4px 0;width:100%}
 .mobile-navbar__bar{display:flex;direction:rtl;justify-content:flex-start;align-items:center;gap:16px;width:100%}
 .mobile-navbar__brand{margin:0;flex:0 0 auto}.mobile-navbar__brand img{height:40px!important;width:auto}
 .mobile-navbar__actions{display:flex;direction:rtl;gap:4px;flex-direction:row-reverse}
 .mobile-profile-trigger,.mobile-navbar__actions .mobile-notification-trigger{position:relative;display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;border:0;border-radius:12px;background:transparent;color:#e4e4e9;text-decoration:none;font-size:19px;flex-shrink:0}
 .mobile-profile-trigger:hover,.mobile-notification-trigger:hover{background:rgba(239,177,0,.08);color:var(--bs-gold-light,#efb100)}
 .mobile-profile-trigger:focus-visible,.mobile-notification-trigger:focus-visible{outline:2px solid #efb100;outline-offset:1px}
 .mobile-notification-trigger__badge{top:2px;right:1px;left:auto;font-size:9px;min-width:15px;height:15px;padding:0 3px}
 .mobile-menu-overlay{display:flex;align-items:center;justify-content:center;padding:12px;padding-top:max(12px,env(safe-area-inset-top));padding-bottom:max(12px,env(safe-area-inset-bottom))}
 .mobile-menu-panel{width:min(440px,100%);max-height:calc(100dvh - 24px);padding:16px;border-radius:22px;overscroll-behavior:contain;outline:none}
 .mobile-menu-panel__header{align-items:center;gap:10px;margin-bottom:12px}.mobile-menu-panel__eyebrow{font-size:10px;margin-bottom:3px}.mobile-menu-panel__title{font-size:14px}.mobile-menu-panel__close{width:44px;height:44px;border-radius:12px}
 .mobile-menu-links{grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
 .mobile-menu-link{position:relative;min-width:0;min-height:52px;padding:8px;gap:7px;border-radius:12px}
 .mobile-menu-link__icon{width:28px;height:28px;border-radius:9px;font-size:14px}
 .mobile-menu-link__title{font-size:12px;line-height:1.6;font-weight:600}
 .mobile-menu-link__meta,.mobile-menu-link__arrow{display:none}
 .mobile-menu-link .badge-coming-soon{position:absolute;left:5px;top:2px;font-size:7px;line-height:1;padding:2px 3px;margin:0}
 .mobile-menu-link:focus-visible{outline:2px solid #efb100;outline-offset:1px}
 .mobile-menu-link--logout .mobile-menu-link__icon{background:#ef444414;color:#f19999}
}
@media(max-width:360px){.mobile-menu-panel{padding:12px}.mobile-menu-links{gap:6px}.mobile-menu-link{padding:7px 5px;gap:5px}.mobile-menu-link__title{font-size:11px}}
@media(max-height:540px) and (max-width:991.98px){.mobile-menu-panel{padding:10px}.mobile-menu-panel__header{margin-bottom:6px}.mobile-menu-panel__eyebrow{display:none}.mobile-menu-link{min-height:44px;padding-top:4px;padding-bottom:4px}.mobile-menu-links{gap:5px}}
</style>

<style scoped>
@media(max-width:991.98px){
 .mobile-navbar__bar{justify-content:space-between;gap:12px}
 .mobile-navbar__actions{gap:8px;flex-direction:row;direction:rtl}
 .mobile-navbar__actions .mobile-profile-trigger,
 .mobile-navbar__actions .mobile-notification-trigger{
  width:44px;height:44px;border-radius:13px;
  background:linear-gradient(180deg,rgba(255,255,255,.055),rgba(255,255,255,.025));
  border:1px solid rgba(239,177,0,.16);color:#e6e6eb;font-size:19px;
  box-shadow:0 3px 10px rgba(0,0,0,.08);
 }
 .mobile-navbar__actions .mobile-profile-trigger:hover,
 .mobile-navbar__actions .mobile-notification-trigger:hover{
  color:var(--bs-gold-light,#efb100);border-color:rgba(239,177,0,.3);background:rgba(239,177,0,.07);
 }
 .mobile-navbar__actions .mobile-notification-trigger__badge{top:-4px;right:-3px;left:auto;box-shadow:none}
}
</style>
